import React, { useEffect, useState } from "react";
import Button from "./Button";
import styles from "./Calendar.module.css";
import CalendarDay from "./CalendarDay";
import Spinner from "./Spinner";

import { flashAlert, popup, popupClose } from "../global_js";
import { useSearchParams } from "react-router-dom";

const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function Calendar() {
  const [searchParams] = useSearchParams();

  const [currentDate, setCurrentDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const daysinMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
  const startDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
  const theYear = currentDate.getFullYear();
  const theMonth = currentDate.getMonth();
  const today = new Date();

  let content = [];

  // useEffect(() => {
  //   //check if date needs to be changed.
  //   const month = searchParams.get("m");

  //   if (month && theMonth + 1 != month) {
  //     console.log(month - (theMonth + 1));
  //     const newMonth = theMonth + (month - (theMonth + 1));
  //     console.log(newMonth);
  //     setCurrentDate(currentDate.setMonth(newMonth));
  //   }
  // }, []);

  useEffect(() => {
    setIsLoading(true);
    try {
      getEvents();
    } catch (error) {}
  }, [currentDate]);

  const getEvents = async () => {
    const dateString = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0);
    const res = await fetch("/api/events/" + dateString);
    if (res.ok) {
      const data = await res.json();
      setEvents(data);
      setIsLoading(false);
    }
  };

  function handleNextClick(e) {
    e.preventDefault();
    setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)));
  }
  function handlePrevClick(e) {
    e.preventDefault();
    setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
  }

  let calDayCount = startDay >= 5 && daysinMonth == 31 ? 42 : 35;

  for (let i = 0; i < calDayCount; i++) {
    let theStyle = "";
    if (today.getFullYear() == currentDate.getFullYear() && today.getMonth() == currentDate.getMonth() && today.getDate() == i - startDay + 1) {
      theStyle = "today";
    }
    if (i < startDay || i >= startDay + daysinMonth) {
      content.push({
        style: "non",
        day: Math.floor(Math.random() * 1000),
        theDate: null,
        theEvents: [],
        theKey: i,
      });
    }
    if (i >= startDay && i < startDay + daysinMonth) {
      content.push({
        style: theStyle,
        day: i - (startDay - 1),
        theDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), i - (startDay - 1)),
        theEvents: events.filter((evt) => evt.dom == i - (startDay - 1)),
        theKey: i,
      });
    }
  }

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <section className={styles.calendar}>
          <div className={styles.calendarHeader}>
            <p>
              <Button type="pOutline" onClick={handlePrevClick}>
                <i className="fa-solid fa-backward"></i> Prev
              </Button>
            </p>
            <h3>
              {monthNames[theMonth]} {theYear}
            </h3>
            <p>
              <Button type="pOutline" onClick={handleNextClick}>
                Next <i className="fa-solid fa-forward"></i>
              </Button>
            </p>
          </div>
          <div className={styles.calendarDoW}>
            <div>Su</div>
            <div>Mo</div>
            <div>Tu</div>
            <div>We</div>
            <div>Th</div>
            <div>Fr</div>
            <div>Sa</div>
          </div>
          <div className={styles.calendarBody}>
            {content.map((d) => {
              return <CalendarDay day={d.day} style={d.style} theDate={d.theDate} theEvents={d.theEvents} key={d.theKey} />;
            })}
          </div>
        </section>
      )}
    </>
  );
}

export default Calendar;
